export default __webpack_public_path__ + "scripts/resource/d8c0e9e71747ca9483951f428cb940ba.svg";